import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/attom-tax-assessor-status")({
  beforeLoad: () => {
    throw redirect({
      to: "/operator/setup",
      search: { tab: "attom-status", partiesTab: "parties" },
      replace: true,
    });
  },
  component: () => null,
});
